import {connect} from 'react-redux';

import {globalWindow} from '../../../../../../libs/shared/core/src/helpers/browser/browserHelpers';
import {authenticateUrlForWindow} from '../../../../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {UploadedAttachmentModel} from '../../../../../../libs/shared/core/src/models/api/attachmentModel';
import {httpToken} from '../../../../../../libs/shared/core/src/services/http/httpBase';
import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {
  downloadAttachmentAsync,
  DownloadAttachmentOptions,
  PreviewAttachmentOptions,
  previewAttachmentWithDownloadFallbackAsync,
} from '../../../../../services/browser';
import {AppState} from '../../../../../store/appState';
import {CommentViewerSingleImageAttachment} from './commentViewerSingleImageAttachment';

/*
 * Props.
 */

interface CommentViewerSingleImageAttachmentContainerProps {
  attachment: UploadedAttachmentModel;
  isInteractionDisabled?: boolean;
}

/*
 * Selectors.
 */

function getAttachmentUrl(_state: AppState, props: CommentViewerSingleImageAttachmentContainerProps) {
  return props.attachment.url;
}

function makeGetAttachmentDownloadUrl() {
  return createSelector([getAttachmentUrl], (attachmentUrl) =>
    authenticateUrlForWindow(globalWindow, attachmentUrl, {access_token: httpToken()}),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CommentViewerSingleImageAttachmentContainerProps>()(() => ({
  attachmentDownloadUrl: makeGetAttachmentDownloadUrl(),
}));

export const CommentViewerSingleImageAttachmentContainer = connect(
  mapStateToProps,
  null,
  (stateProps, _dispatchProps, ownProps) => {
    const {attachment} = ownProps;

    const onPreviewClickAsync = (options: PreviewAttachmentOptions) =>
      previewAttachmentWithDownloadFallbackAsync(attachment, options);
    const onDownloadClickAsync = (options: DownloadAttachmentOptions) =>
      downloadAttachmentAsync(attachment, options);

    return {
      ...stateProps,
      ...ownProps,
      onPreviewClickAsync,
      onDownloadClickAsync,
    };
  },
)(CommentViewerSingleImageAttachment);
